import { useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import Button from "../../components/button";
import TextField from "../../components/textField/textField";
import { useSafeNavigate } from "../../components/unloadBlocker";
import { useAppContext } from "../../context/appContext";
import { sha256 } from "../../utils/passwordUtils";

export default function SignUpPage() {

    const {accountController} = useAppContext();

    const navigate = useSafeNavigate(useNavigate());

    const [error, setError] = useState<string | undefined>(undefined);
    const [password, setPassword] = useState("");
    const [repeatPassword, setRepeatPassword] = useState("");
    const [email, setEmail] = useState("");

    const [isLoading, setIsLoading] = useState(false);

    async function register() {
        if(!email || !password || !repeatPassword) {
            setError("Please fill in all fields.");
            return;
        }
        if(password !== repeatPassword) {
            setError("Passwords do not match.");
            return;
        }
        if(password.length < 8) {
            setError("Password must be at least 8 characters long.");
            return;
        }
        if(!email.includes("@")) {
            setError("Please enter a valid email address.");
            return;
        }
        setIsLoading(true);
        accountController.register({
            email: email,
            password: await sha256(password)
        }).catch((err) => {
            setError(err.response.data.message || "An error occurred during registration.");
            setIsLoading(false);
        }).then((result) => {
            console.log(result);
            if(result) {
                navigate("/signup/verifyEmail/" + result.data);
            }
            setIsLoading(false);
        });
    }

    return <>
        <Helmet>
            <title>Sign Up | Txoria</title>
        </Helmet>
        <TextField onEnter={register} autoFocus placeholder="Email..." label="Email" value={email} onChange={setEmail} type="email"/>
        <TextField showPasswordEye onEnter={register} placeholder="Password..." label="Password" value={password} onChange={setPassword} type="password"/>
        <TextField onEnter={register} placeholder="Repeat Password..." label="Repeat Password" value={repeatPassword} onChange={setRepeatPassword} type="password"/>
        <p className="error">{error}</p>
        <Button loading={isLoading} onClick={register}>Sign Up</Button>
    </>;
}